import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/");
      return;
    }
    api.post("/auth/session", { session_id: m[1] }, { withCredentials: true })
      .then(async (r) => {
        // Sync context immediately from the response.
        setUser({ ...r.data.user, is_admin: !!r.data.is_admin });
        // Belt-and-suspenders: re-hydrate from /auth/me so context matches
        // exactly what the backend considers the current session (covers
        // Edge/Safari edge cases with cookie-set timing).
        try { await refreshUser(); } catch {}
        window.history.replaceState({}, "", "/admin/crm");
        toast.success(`Benvenuto ${r.data.user.name || r.data.user.email}`);
        nav("/admin/crm", { replace: true });
      })
      .catch((e) => {
        const msg = e?.response?.data?.detail || "Errore di autenticazione";
        toast.error(msg);
        nav("/", { replace: true });
      });
  }, [nav, setUser, refreshUser]);

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="animate-spin text-navy mx-auto" size={32} />
        <p className="mt-4 text-sm text-slate-600 font-mono">Autenticazione amministratore…</p>
      </div>
    </div>
  );
}
